import {
  Breadcrumb,
  BreadcrumbButton,
  BreadcrumbDivider,
  BreadcrumbItem,
  makeStyles,
  Title3,
  tokens,
} from "@fluentui/react-components"
import { Fragment, type ReactNode } from "react"
import { useNavigate } from "react-router"

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalL,
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: tokens.spacingHorizontalM,
    flexWrap: "wrap",
  },
  description: {
    color: tokens.colorNeutralForeground3,
    margin: 0,
  },
})

export interface BreadcrumbEntry {
  label: string
  // Sin `to`, la entrada es la página actual (no navegable)
  to?: string
}

export interface PageHeaderProps {
  title: string
  description?: string
  breadcrumb?: BreadcrumbEntry[]
  // Command bar de la página (Toolbar con acciones)
  actions?: ReactNode
}

export const PageHeader = ({ title, description, breadcrumb, actions }: PageHeaderProps) => {
  const styles = useStyles()
  const navigate = useNavigate()
  return (
    <header className={styles.root}>
      {breadcrumb && breadcrumb.length > 0 ? (
        <Breadcrumb size="small" aria-label={title}>
          {breadcrumb.map((entry, index) => (
            <Fragment key={`${entry.label}-${entry.to ?? index}`}>
              {index > 0 ? <BreadcrumbDivider /> : null}
              <BreadcrumbItem>
                <BreadcrumbButton
                  current={index === breadcrumb.length - 1}
                  onClick={entry.to ? () => navigate(entry.to as string) : undefined}
                >
                  {entry.label}
                </BreadcrumbButton>
              </BreadcrumbItem>
            </Fragment>
          ))}
        </Breadcrumb>
      ) : null}
      <div className={styles.titleRow}>
        <Title3 as="h1">{title}</Title3>
        {actions}
      </div>
      {description ? <p className={styles.description}>{description}</p> : null}
    </header>
  )
}
